import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-2 flex-col mt-4" }
const _hoisted_2 = { class: "flex justify-between px-10 mb-5 sm:mb-0" }
const _hoisted_3 = { class: "h-80 animate-pulse bg-background-medium rounded-md shadow w-full" }
const _hoisted_4 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-10 w-10 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "flex justify-between items-center"
}
const _hoisted_9 = { class: "text-lg font-bold" }
const _hoisted_10 = {
  key: 2,
  class: "pt-5 font-light"
}
const _hoisted_11 = {
  key: 3,
  class: "pt-5 font-medium"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 4,
  class: "flex items-center justify-between py-4"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { class: "flex justify-between items-center" }
const _hoisted_17 = { class: "font-bold mb-4 sm:mb-0" }
const _hoisted_18 = {
  key: 0,
  class: "w-auto"
}
const _hoisted_19 = {
  key: 0,
  class: "w-full flex justify-center py-8"
}
const _hoisted_20 = {
  key: 1,
  class: "flex mt-4"
}
const _hoisted_21 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_22 = { class: "font-bold text-2xl w-full text-center pt-10 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bread_crumbs = _resolveComponent("bread-crumbs")!
  const _component_entity_actions = _resolveComponent("entity-actions")!
  const _component_the_carousel = _resolveComponent("the-carousel")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_baseIcon = _resolveComponent("baseIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_CircleLoader = _resolveComponent("CircleLoader")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_SpeechBubble = _resolveComponent("SpeechBubble")!
  const _component_CardComponent = _resolveComponent("CardComponent")!
  const _component_the_grid = _resolveComponent("the-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_bread_crumbs, {
      class: _normalizeClass(["mx-4 sm:mx-0", _ctx.loading ? 'animate-pulse' : ''])
    }, null, 8, ["class"]),
    (_ctx.result && _ctx.result.Entity)
      ? (_openBlock(), _createBlock(_component_entity_actions, {
          key: 0,
          class: "hidden mt-10 lg:inline-flex",
          entity: _ctx.result.Entity
        }, null, 8, ["entity"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, [
        _createElementVNode("section", _hoisted_2, [
          _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
            [_vShow, _ctx.loading]
          ]),
          (!_ctx.loading && _ctx.carouselFiles)
            ? (_openBlock(), _createBlock(_component_the_carousel, {
                key: 0,
                source: _ctx.carouselFiles,
                infotext: _ctx.t('main.info'),
                mediafiles: _ctx.mediaFiles,
                "is-touch": _ctx.route.query.touch ? true : false,
                "mediafile-url": _ctx.mediafileUrl,
                onOpeningCcmodal: _ctx.openCCModal,
                onCurrentPictureIndex: _ctx.setPictureIndex
              }, null, 8, ["source", "infotext", "mediafiles", "is-touch", "mediafile-url", "onOpeningCcmodal", "onCurrentPictureIndex"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.result && _ctx.result.Entity)
          ? (_openBlock(), _createBlock(_component_entity_actions, {
              key: 0,
              class: "my-10 lg:hidden",
              entity: _ctx.result.Entity
            }, null, 8, ["entity"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_CardComponent, {
        large: true,
        class: "mx-2 md:mx-4 sm:mx-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex bg-background-medium px-0 md:px-10 py-10", { [`animate-pulse h-80 justify-center items-center flex-col overflow-hidden`]: _ctx.loading, [`flex-col`]: !_ctx.loading }])
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.result.Entity?.title[0]?.value), 1),
                  _createVNode(_component_BaseIcon, {
                    title: "Melden kwetsende content",
                    class: "cursor-pointer",
                    icon: "alert",
                    onClick: _ctx.openOffensiveContentModal
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.result.Entity?.description[0]?.value), 513), [
                    [_vShow, _ctx.result.Entity?.description && _ctx.result.Entity?.description[0]]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterDuplicateTypes(_ctx.types), (metaData) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: metaData.id,
                      class: "inline-block px-2 py-2 bg-background-dark mr-4 mb-4 bg-opacity-50 cursor-pointer hover:underline",
                      onClick: ($event: any) => (_ctx.goToRelation(metaData))
                    }, _toDisplayString(metaData.label), 9, _hoisted_12))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.carouselFiles)
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 0,
                        class: "inline⁻block w-max ml-3 mt-3 hover:underline",
                        text: _ctx.t('details.more'),
                        "custom-style": "ghost-black",
                        "custom-icon": "info",
                        "icon-shown": true,
                        "on-click": _ctx.openDetailsModal
                      }, null, 8, ["text", "on-click"]))
                    : _createCommentVNode("", true),
                  (_ctx.isDownloadable && !_ctx.route.query.touch)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "bg-background-light rounded-full p-4",
                        href: _ctx.generateUrl(_ctx.result.Entity?.mediafiles[_ctx.carouselPictureIndex].filename, 'full'),
                        target: "_blank",
                        download: ""
                      }, [
                        _createVNode(_component_baseIcon, { icon: "download" })
                      ], 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.useTestimonyFeature && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.t('details.testimony')), 1),
                    _createVNode(_component_tool_tip, {
                      title: _ctx.t('main.tooltips.login.title'),
                      description: _ctx.t('main.tooltips.login.description'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.route.query.touch)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_BaseButton, {
                                "custom-icon": "talk",
                                "icon-shown": true,
                                "custom-style": "secondary",
                                text: _ctx.t('details.addTestimony'),
                                onClick: _ctx.writeTestimony
                              }, null, 8, ["text", "onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["title", "description"])
                  ]),
                  (_ctx.loadingNewTestimony)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_CircleLoader)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isWritingTestimony)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_BaseInput, {
                          styling: "w-full",
                          icon: "send",
                          placeholder: _ctx.t('details.testimonyPlaceholder'),
                          onSubmitField: _ctx.createNewTestimony
                        }, null, 8, ["placeholder", "onSubmitField"])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonies, (testimony, index) => {
                    return (_openBlock(), _createBlock(_component_SpeechBubble, {
                      key: testimony.name,
                      "card-details": testimony,
                      color: "#FDC20B",
                      alignment: index % 2 == 0 ? 'Left' : 'Right',
                      onReceivedLike: _ctx.updateTestimonyLikes
                    }, null, 8, ["card-details", "alignment", "onReceivedLike"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }),
      (_ctx.relatedItemIds.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
            _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.t('details.discover')), 1),
            _createVNode(_component_the_grid, {
              small: _ctx.route.query.touch ? false : true,
              "default-relations": _ctx.relatedItemIds
            }, null, 8, ["small", "default-relations"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}